export default {
  label: 'Gender',
  placeholder: 'All',
};
